// A module's own strip across the top of its pages (`header` in its registry; no module uses one since Find's guided path
// went on 20 Oct 2026), and where its menu entry
// leads when the module decides its own landing (`landing`). Drawn by the layout.
import { Suspense } from "react";
import { MODULE_DEFS } from "../../modules";

/** The registry's header for this section, if it has one. Loaded lazily: nothing shows until it is ready. */
export function ModuleHeader({ section }: { section: string }) {
  const def = MODULE_DEFS.find((m) => m.key === section);
  if (!def || def.layout !== "steps" || !def.header) return null;
  return <Suspense fallback={null}>{def.header()}</Suspense>;
}

/** `/campaigns` for a module with its own landing (the route there decides), else null (use the menu's usual home). */
export function moduleEntry(section: { key: string }): string | null {
  const def = MODULE_DEFS.find((m) => m.key === section.key);
  return def && def.layout === "steps" && def.landing ? `/${def.key}` : null;
}
